class HartyValidator {
  static validateLoginData(username, password) {
    return;
  }
  static validateRegisterData(
    username: string,
    password: string,
    confirmPassword: string,
    email: string,
    firstName: string,
    lastName: string,
    age: number,
    gender: number
  ) {
    if (password !== confirmPassword) {
      throw new Error("Password not matched");
    }
    return;
  }
}

export default HartyValidator;
